// Update visibility and publish status for content videos

import { AxiosInstance } from '../common/Loader/axios.config';

export const updateVisibility = async (
  eventId: string,
  category: string,
  data: {
    visibility: boolean;
    publish: boolean;
  }
): Promise<void> => {
  try {
    const payload = {
      status: {
        type: "normal",
        lifetype: 365,
        promoted: false,
        live: false,
        visibility: data.visibility,
        publish: data.publish,
      },
    };

    const response = await AxiosInstance.put(
      `/${eventId}/content-videos`,
      payload
    );

    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    console.log(
      `Visibility and/or publish updated successfully for ${eventId}`,
      response.data
    );
  } catch (error) {
    console.error(
      `Error updating visibility and/or publish for ${eventId}:`,
      error
    );
    throw error;
  }
};
